export const ERROR: string = 'Campo requerido'

export const USERNAME: string = 'Nombre de usuario'
export const ERROR_USERNAME: string = 'El nombre de usuario es requerido'

export const PASSWORD: string = 'Contraseña'
export const ERROR_PASSWORD: string = 'La contraseña es requerida'